import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useStore } from '../../context/store.provider'
import { ROUTES_LINKS } from '../../routes/routes'
import MainSearchBar from '../user/Search/MainSearchBar'
import { priceFormatter } from './algoritem'
import './List.css'
function List() {
  const {filteredStoreProducts,handleFilterKeyInput} = useStore()
  const navigate = useNavigate();
  
  const handleNavigationToAdminSite =()=>{
    navigate(ROUTES_LINKS.TO_ADMIN_SITE)
  }
  const onClickEdit = (id) => {    
    navigate(ROUTES_LINKS.TO_EDIT_PRODUCT.replace(':id', id));
  }
  console.log(filteredStoreProducts);
  
  return (
    <>
        <button onClick={handleNavigationToAdminSite}><i className="fa-solid fa-backward"></i>חזרה לאתר מנהל  </button>
        <div className='search-bar'>
      <input style={{position:"fixed",top:15,textAlign:"center",width:175}} placeholder='חיפוש מוצרים' onChange={handleFilterKeyInput} type="text" />
    </div>
    <div className='list-con'>
      {filteredStoreProducts.map(({productName, id, category, storePrice,price,})=>
        <div className='list-product-con' key={id}>
          <h2>{productName}</h2>
          <h3>{category}</h3>
          <h4>{storePrice}</h4>
          <h4>{priceFormatter.format(price)}</h4>
          <button className='edit-product' onClick={() => onClickEdit(id)}>Edit </button>
        </div>
     )}
    </div>
    </>
  )
}

export default List